import { render, staticRenderFns } from "./floatData.vue?vue&type=template&id=0df1f964&"
import script from "./floatData.vue?vue&type=script&lang=js&"
export * from "./floatData.vue?vue&type=script&lang=js&"
import style0 from "./floatData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports